export const getExtent = ([start, end]: number[]) => end - start;
